var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.977,
    height: 11.403,
    viewBox: "0 0 9.977 11.403",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M1196.553,493.337a1.425,1.425,0,0,0,1.425-1.425h-2.85A1.425,1.425,0,0,0,1196.553,493.337Zm0-10.035-.568.114a2.854,2.854,0,0,0-2.283,2.8,15.417,15.417,0,0,1-.327,2.666,9.238,9.238,0,0,1-.472,1.609h7.3a9.223,9.223,0,0,1-.472-1.609,15.426,15.426,0,0,1-.327-2.666,2.853,2.853,0,0,0-2.283-2.794l-.568-.116Zm4.433,7.184a1.806,1.806,0,0,0,.556.713h-9.977a1.8,1.8,0,0,0,.555-.713,12.6,12.6,0,0,0,.87-4.275,3.564,3.564,0,0,1,2.854-3.493.713.713,0,1,1,1.418-.142.673.673,0,0,1,0,.142,3.564,3.564,0,0,1,2.854,3.493A12.6,12.6,0,0,0,1200.986,490.486Z",
    transform: "translate(-1191.565 -481.934)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNotification);
export default __webpack_public_path__ + "static/media/ic-notification.4d2e7439c4a3e1fa3f911653fe58659a.svg";
export { ForwardRef as ReactComponent };